import TrendingFire from '@/icons/trending-fire';

export interface ViewCountPillProps {
  viewCount: number;
  /** Needed to have different svg gradient IDs between desktop and mobile */
  svgGradientKey?: string;
}

export default function ViewCountPill({ viewCount, svgGradientKey }: ViewCountPillProps) {
  return (
    <div className="flex flex-shrink-0 items-center justify-center gap-[4px] rounded-[32px] bg-flexcar-neutral100 py-[4px] pl-[8px] pr-[12px] md:py-[8px] md:pl-[12px]">
      <TrendingFire
        className="h-[16px] w-[16px] flex-shrink-0 md:h-[20px] md:w-[20px]"
        gradientKey={svgGradientKey}
      />
      <p className="body3-tight font-bold leading-[18px] tracking-normal text-flexcar-neutral0 md:text-[14px] md:leading-[20px]">
        {viewCount} views
        <span className="font-medium md:font-normal"> last 24hr</span>
      </p>
    </div>
  );
}
